/**
 * Actions for Create Event
 */
export enum createEvent {
  CREATE_EVENT_REQUEST = 'CREATE_EVENT_REQUEST',
  CLEAR_EVENT_DETAILS = 'CLEAR_EVENT_DETAILS,'
}

export enum updateEvents {
  UPDATE_EVENT_REQUEST = 'UPDATE_EVENT_REQUEST'
}

/**
 * Action for Fetch Event
 */
export enum getEventType {
  FETCH_EVENT_REQUEST = 'FETCH_EVENT_REQUEST'
}

/**
 * Action for Patch Status Event
 */
export enum patchEventStatusType {
  PATCH_EVENT_STATUS_REQUEST = 'PATCH_EVENT_STATUS_REQUEST'
}
